import iconStopWatch from '@/components/ielts/speaking/images/icon_stopwatch.png';
import { BalooBhaifont } from '@/lib/utils';
import time, { ConfigType } from '@flyer/utils/time';
import useTranslation from 'next-translate/useTranslation';
import Image from 'next/image';
import { useEffect, useMemo, useRef, useState } from 'react';
import { twMerge } from 'tailwind-merge';

const calcLeft = (target?: ConfigType) => {
  if (!target) {
    return 0;
  }
  const left = time(target).valueOf() - Date.now();
  return left < 0 ? 0 : left;
};

function useLatest<T>(value: T) {
  const ref = useRef(value);
  ref.current = value;

  return ref;
}

const parseMs = (milliseconds: number) => {
  return {
    days: Math.floor(milliseconds / 86_400_000),
    hours: Math.floor(milliseconds / 3_600_000) % 24,
    minutes: Math.floor(milliseconds / 60_000) % 60,
    seconds: Math.floor(milliseconds / 1000) % 60,
    milliseconds: Math.floor(milliseconds) % 1000,
  };
};
function CountDown({ target, onTimeout }: { target: number; onTimeout: () => void }) {
  const [timeLeft, setTimeLeft] = useState(() => calcLeft(target));
  const { t } = useTranslation('ielts');
  const onEndRef = useLatest(onTimeout);

  useEffect(() => {
    if (!target) {
      // for stop
      setTimeLeft(0);
      return;
    }

    setTimeLeft(calcLeft(target));

    const clearer = setInterval(() => {
      const targetLeft = calcLeft(target);
      setTimeLeft(targetLeft);
      if (targetLeft === 0) {
        clearInterval(clearer);
        onEndRef.current?.();
      }
    }, 1000);

    return () => clearInterval(clearer);
  }, [onEndRef, target]);

  const formattedRes = useMemo(() => time.duration(parseMs(timeLeft)), [timeLeft]);

  return (
    <div
      data-test-id="time-count-down"
      className={twMerge(
        'flex flex-row gap-[12px] items-center justify-center',
        BalooBhaifont.className,
      )}
    >
      <Image alt="flyer" src={iconStopWatch} className="w-[30px] h-[34px]" />
      <span
        className="text-[32px] font-[400] [-webkit-text-stroke-width:1.5px] [-webkit-text-stroke-color:#000000] text-white"
        style={{
          textShadow: '0px 2px 0px #000',
        }}
      >
        {formattedRes.format('mm:ss')}
      </span>
      <span className="hidden md:block text-[20px] text-[#000] font-[400]">
        {t('DoSpeaking.minutes_remaining')}
      </span>
    </div>
  );
}

export default CountDown;
